<div class="dashboard-container">
    <app-page-header headline="Willkommen, {{ customer().fullName }}!" />
    <div class="dashboard-card-container m-24:b md:m-48:b">
        @for (card of cards; track card.route) {
            <a
                class="dashboard-card"
                [ngClass]="card.class"
                [routerLink]="card.route"
            >
                <span>
                    <i [ctrlIcon]="card.icon ?? 'account'"></i>
                </span>
                <span [innerHTML]="card.title"></span>
            </a>
        }
    </div>

    <h1 class="c:blue-700 dashboard-title">Deine Verträge</h1>

    <div class="contracts-container m-16:t md:m-24:t">
        @if (contractsPending()) {
            <app-placeholder-card />
            <app-placeholder-card />
            <app-placeholder-card />
        } @else {
            <app-contract-list
                [contracts]="contracts()"
                route="/portal/meine-vertraege/:contractId"
            />
        }
    </div>
</div>
